var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_vm._v("\n  "+_vm._s(_vm.item.days)+":\n  "),_c('div',{staticClass:"item__hours"},_vm._l((_vm.item.hours),function(h,hIdx){return _c('div',{key:((_vm.item.days) + "_" + hIdx)},[_vm._v(_vm._s(h))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }